// @flow
import { defineMessages } from 'react-intl';

const youAreAbout = 'You are about to delete {device}.';

export default defineMessages({
    cancelOrConfirm: {
        id: 'info-panel.cancel-or-confirm',
        defaultMessage: `${youAreAbout} Please cancel to return to the device screen or confirm you wish to delete`
    },
    cancelOrConfirmZone: {
        id: 'info-panel.cancel-or-confirm-zone',
        // eslint-disable-next-line max-len
        defaultMessage: `${youAreAbout} Please cancel to return to the device screen or confirm you wish to delete the thermostat and receiver for this zone.`
    },
    removeDeviceTitle: {
        id: 'info-panel.remove-device-title',
        defaultMessage: 'Remove device'
    },
    removeHueTitle: {
        id: 'info-panel.remove-hue-title',
        defaultMessage: 'Delete Philips Hue'
    },
    removeHueText: {
        id: 'info-panel.remove-hue-text',
        defaultMessage: 'Deleting the Philips Hue Bridge will remove all the devices connected to it.'
    },
    removeZoneTitle: {
        id: 'info-panel.remove-zone-title',
        defaultMessage: 'Remove zone'
    }
});



// WEBPACK FOOTER //
// ./src/core/i18n/components/widgets/remove-device/intl.js